<template>
	<el-drawer title="赠送优惠券" :visible.sync="visible" @close='close' size="1000px" :close-on-press-escape="false" :wrapperClosable="false" :modal-append-to-body="false">
		<div class="drawerView">
			<div class="drawerViewT">
				<div>
					<el-table :data="tableData">
						<el-table-column label="编号" width="50">
							<template slot-scope="scope">
								{{scope.$index+1}}
							</template>
						</el-table-column>
						<el-table-column label="洗美卡名称" width="220" >
							<template slot-scope="scope">
								{{scope.row.title}}
							</template>
						</el-table-column>
						<el-table-column label="类型" width="80">
							<template slot-scope="scope">
								{{scope.row.apply_type&&scope.row.apply_type.title}}
							</template>
						</el-table-column>
						<el-table-column label="分类" width="80">
							<template slot-scope="scope">
								{{scope.row.category_info&&scope.row.category_info.name}}
							</template>
						</el-table-column>
						<el-table-column label="洗美服务" >
							<template slot-scope="scope">
								{{scope.row.service_details[0].service_name}}
							</template>
						</el-table-column>
						<el-table-column label="规格" width="170">
							<template slot-scope="scope">
								{{scope.row.service_details[0].service_objectName}}
							</template>
						</el-table-column>
						<el-table-column label="可用次数" width="100">
							<template slot-scope="scope">
								{{scope.row.total_count}}
							</template>
						</el-table-column>
						<el-table-column label="操作">
							<template slot-scope="scope">
								<el-button type="text" size="small" @click='send(scope.row)'>赠送</el-button>
							</template>
						</el-table-column>
					</el-table>
					<div class="pagePosi">
						<page style="padding:10px 0;" :page="page.page" :total="page.total" @change="changePage"></page>
					</div>
				</div>
			</div>
		</div>

	</el-drawer>
</template>

<script>
	import page from "@/components/page.vue"
	export default {
		components:{page},
		data() {
			return {
				visible: true,
				userDetail:{},
				
				page:{
					page:1,
					pageSize:10,
					total:0,
				},
				tableData:[],
				
			}
		},
		props:{
			memberId:{
				default:''
			},
		},
		mounted(){
			this.getTableData()
			this.getUserDetail()
		},
		methods: {
			close() {
				this.$emit("submit", {type:'close'});
			},
			//提交
			send(row){
				let params = {
					"member_id": this.memberId,
					"virtual_id": row.virtualId,  //虚拟卡id
					"detail_id": row.service_details[0].detail_id,  // 明细id
					"pet_id": "",  // 宠物id
					"pet_name": "",  // 宠物名称
					"create_time": "", 
					"unit_price": 0, // 实收的总价
					"soure_type": 2,  // 1 销售 2 赠送
					"source_order_no": "", // 订单号
					"shop_id": "",   // 门店id
				}
				let loading = this.$loading()
				this.$http.post(process.env.VUE_APP_member + '/api/memberBindCard/bindCard', params).then((res) => {
					loading.close()
					if (res.code == 0) {
						this.$message({
							type: 'success',
							message: '操作成功'
						});
						this.$emit("submit", {type:'success'});
					}
				})
			},
			
			// 优惠券列表
			changePage(num){
				this.page.page=num;
				this.getTableData()
			},
			getTableData(){
				let params = {
					"keyword": "",
					"categoryId": "",
					"shopId": "",
					"status": "",
					"weight": 0,
					"applyType": "0",
					"pageIndex": this.page.page,
					"pageSize": this.page.pageSize,
				}
				this.$http.post(process.env.VUE_APP_baseData + '/api/product/virtual/card/list', params).then((res) => {
					if (res.code == 0) {
						this.tableData = res.data.data;
						this.page.total = res.data.count;
					}
				})
			},
			getUserDetail() {
				let params = {
					"id": this.memberId,
				}
				this.$http.get(process.env.VUE_APP_member+'/api/middleware/Member/Single', params).then(res => {
					if (res.code == 0) {
						this.userDetail = res.data;
					}
				})
			},
		},
	}
</script>

<style scoped lang="scss">
	#comDrawer {
		::v-deep .el-drawer__header {
			padding: 20px;
			margin-bottom: 0;
		}

		::v-deep .el-drawer__body {
			height: calc(100% - 65px);
			overflow-y: auto;
		}
	}

	.drawerView {
		height: 100%;
		display: flex;
		flex-direction: column;
		.drawerViewT {
			flex: 1;
			box-sizing: border-box;
			border-top: solid 1px #F2F2F2;
			overflow-y: scroll;
			.drawerCom{
				display: flex;
				margin-top: 32px;
				.drawerComL{
					width: 132px;
					margin-right: 22px;
					font-size: 14px;
					color: #343440;
					text-align: right;
					line-height: 20px;
					margin-top: 12px;
				}
				.drawerComR{
					flex: 1;
					.drawerSelect{
						display: flex;
						.drawerSelectItem{
							width: 128px;
							height: 44px;
							box-sizing: border-box;
							font-size: 14px;
							color: #69697B;
							text-align: center;
							line-height: 44px;
							position: relative;
							background: #FAFAFD;
							border-radius: 8px;
							margin-right: 16px;
							div:nth-of-type(1){
								position: absolute;
								left: 16px;
								top: 0;
								bottom: 0;
								margin: auto 0;
								width: 16px;
								height: 16px;
								border-radius: 100%;
								border: solid 1px #B0B0BF;
							}
						}
						.drawerSelectActiveItem{
							width: 128px;
							height: 44px;
							box-sizing: border-box;
							font-size: 14px;
							color: #577BFF;
							text-align: center;
							line-height: 44px;
							position: relative;
							background: #FAFAFD;
							border-radius: 8px;
							margin-right: 16px;
							border: 1px solid #577BFF;
							div:nth-of-type(1){
								position: absolute;
								left: 16px;
								top: 0;
								bottom: 0;
								margin: auto 0;
								width: 4px;
								height: 4px;
								border-radius: 100%;
								border: solid 6px #577BFF;
							}
						}
					}
				}
			}
		}

		.drawerViewT::-webkit-scrollbar {
			display: none;
		}

		.drawerViewB {
			height: 60px;
			display: flex;
			justify-content: flex-end;
			align-items: center;
			padding: 0 20px;
			border-top: solid 1px #F2F2F2;
			box-sizing: border-box;

			.btn {
				width: 98px;
				line-height: 40px;
				text-align: center;
				background: linear-gradient(135deg, #5685FF 0%, #3569FF 100%);
				border-radius: 10px;
				font-size: 16px;
				font-weight: bold;
				color: #fff;
				cursor: pointer;
				margin-left: 20px;
			}

			.btn2 {
				width: 98px;
				line-height: 40px;
				text-align: center;
				border-radius: 10px;
				font-size: 16px;
				font-weight: bold;
				cursor: pointer;
				box-sizing: border-box;
				border: solid 1px #577BFF;
				color: #577BFF;
			}
		}
		.pagePosi{
			width:100%;text-align: right;background-color: #fff;border-radius: 8px;padding:0 10px;box-sizing: border-box;position: relative;z-index: 1;
		}
	}
</style>
